import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';


const QMap = () => {
  const [pharmacies, setPharmacies] = useState([]);

  useEffect(() => {
    const fetchPharmacies = async () => {
const token = localStorage.getItem("authToken");
try {
  const response = await fetch('https://api.pharmacegroup.co.uk/api/pharmacies', {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  const data = await response.json();

  const members = JSON.parse(localStorage.getItem("members") || "[]");
  const allowedPharmacyNames = members.map(m => m.pharmacyName);

  const filteredData = data.filter(pharmacy =>
    allowedPharmacyNames.some(name => name.trim() === (pharmacy.name || "").trim())
  );

  setPharmacies(filteredData);
} catch (error) {
  console.error('Error fetching pharmacies:', error);
}
    };

    fetchPharmacies();
  }, []);

  return (
    <div style={{ height: '750px', width: '100%' }}>
      <h2></h2>
      <MapContainer center={[54.0, -2.0]} zoom={6} style={{ height: '100%' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {pharmacies.map((pharmacy, index) => {
          if (pharmacy.location) {
            return (
              <Marker
                key={index}
                position={[pharmacy.location.lat, pharmacy.location.lng]}
                icon={new L.Icon({
                  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
                  iconSize: [25, 41],
                  iconAnchor: [12, 41],
                  popupAnchor: [1, -34],
                })}
              >
                <Popup>
                  <div>
                    <strong>{pharmacy.name}</strong>
                    <br />
                    {pharmacy.address}
                    <br />
                    {pharmacy.postcode}
                  </div>
                </Popup>
              </Marker>
            );
          }
          return null;
        })}
      </MapContainer>
    </div>
  );
};

export default QMap;
